var _path, _path2, _path3, _path4, _path5, _path6, _path7, _path8, _path9, _g, _path10, _path11, _path12;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgOxTxtLogo(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 1175,
    height: 211,
    viewBox: "0 0 1175 211",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M267.537 46.4521H224.692L200.489 84.5245L177.505 46.4521H132.762L173.104 110.021L132.762 169.431L177.666 169.736L267.537 46.4521Z",
    fill: "#E5E5E5"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M412.981 99.0223C416.648 75.3058 436.942 62.3487 456.501 62.3487C476.55 62.3487 493.42 75.3058 496.842 99.0223H412.981ZM456.501 45.9678C423.25 45.9678 394.156 70.9066 394.156 109.536C394.156 147.922 423.25 172.615 455.278 172.615C482.418 172.615 503.444 159.413 512.98 134.23L496.353 130.317C487.797 149.633 472.394 156.234 455.278 156.234C434.496 156.234 413.958 140.097 412.248 112.959H515.669V106.112C514.446 70.1727 489.019 45.9678 456.501 45.9678V45.9678Z",
    fill: "#E5E5E5"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M67.9678 139.849C52.0764 139.849 37.6514 127.381 37.6514 108.065C37.6514 88.995 52.0764 76.2807 67.9678 76.2807C83.1268 76.2807 97.5518 88.995 97.5518 108.065C97.5518 127.381 83.1268 139.849 67.9678 139.849M67.9682 43.5186C30.8048 43.5186 0 69.4355 0 108.065C0 146.939 30.8048 172.856 67.9682 172.856C104.398 172.856 135.204 146.939 135.204 108.065C135.204 69.4355 104.398 43.5186 67.9682 43.5186",
    fill: "#E5E5E5"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M348.159 103.912L319.064 97.5547C307.328 94.8659 300.728 90.465 300.728 80.9293C300.728 69.4387 310.263 61.1267 327.378 61.1267C345.226 61.1267 356.716 70.1727 359.161 83.3739L377.009 79.4628C372.608 59.903 355.006 45.9678 327.866 45.9678C300.239 45.9678 282.145 60.6369 282.145 82.3958C282.145 99.0226 293.393 109.047 313.441 113.203L341.069 119.315C353.293 122.004 360.873 126.65 360.873 136.674C360.873 149.143 349.381 157.211 332.023 157.211C312.953 157.211 298.282 148.655 296.572 132.762L277.99 136.919C280.923 160.389 302.929 172.614 330.555 172.614C359.406 172.614 379.21 159.167 379.21 135.452C379.21 117.115 365.762 107.823 348.159 103.912",
    fill: "#E5E5E5"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M213.241 150.034L224.69 169.433H269.677L235.806 119.854L213.241 150.034Z",
    fill: "#E5E5E5"
  })), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M765.857 106.845C765.857 138.14 749.232 155.011 724.049 155.011C704.001 155.011 690.798 140.096 690.798 117.603V48.9014H671.971V121.026C671.971 151.588 691.286 172.369 720.382 172.369C740.43 172.369 756.077 164.057 765.857 149.632V169.192H784.683V48.9014H765.857V106.845Z",
    fill: "#E5E5E5"
  })), _path7 || (_path7 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M1019.26 155.009C1005.81 155.009 997.011 146.207 997.011 130.56V64.5466H1040.04V48.8993H997.011V10.5137H978.185V48.8993H952.024V64.5466H978.185V131.782C978.185 158.432 994.077 172.613 1018.04 172.613C1027.82 172.613 1036.13 169.922 1045.91 163.077L1039.8 147.674C1033.69 152.075 1026.11 155.009 1019.26 155.009",
    fill: "#E5E5E5"
  })), _path8 || (_path8 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M1154.01 48.9014L1110 145.231L1066.97 48.9014H1045.95L1099.98 167.725L1080.18 211H1100.96L1174.79 48.9014H1154.01Z",
    fill: "#E5E5E5"
  })), /*#__PURE__*/React.createElement("mask", {
    id: "mask0_8199_6943",
    style: {
      maskType: "alpha"
    },
    maskUnits: "userSpaceOnUse",
    x: 913,
    y: 0,
    width: 26,
    height: 25
  }, _path9 || (_path9 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M913.112 0H938.785V24.9369H913.112V0Z",
    fill: "white"
  }))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    mask: "url(#mask0_8199_6943)"
  }, /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M925.825 0C918.491 0 913.112 5.86738 913.112 12.4687C913.112 19.5598 918.491 24.9374 925.825 24.9374C933.16 24.9374 938.785 19.5598 938.785 12.4687C938.785 5.86738 933.16 0 925.825 0",
    fill: "#E5E5E5"
  }))), _path10 || (_path10 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M916.535 169.436H935.361V48.9014H916.535V169.436Z",
    fill: "#E5E5E5"
  })), _path11 || (_path11 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M839.486 78.4781V48.8956H820.661V169.429H839.486V122.975C839.486 90.4584 855.867 66.2536 887.897 66.2536C890.096 66.2536 892.786 66.2536 894.987 66.4977L896.453 48.65C893.032 47.6719 890.83 47.6719 887.897 47.6719C865.647 47.6719 849.266 60.6304 839.486 78.4781",
    fill: "#E5E5E5"
  })), _path12 || (_path12 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M592.722 63.0816C610.57 63.0816 626.707 72.8615 632.086 91.4417L649.934 86.0641C642.599 61.3695 619.128 45.9678 592.722 45.9678C558.738 45.9678 529.888 71.3936 529.888 109.291C529.888 147.677 558.738 172.614 592.722 172.614C619.372 172.614 643.088 157.455 649.688 132.762L632.574 128.117C626.707 146.209 610.57 155.255 592.722 155.255C568.028 155.255 547.979 137.407 547.979 109.291C547.979 81.6632 568.028 63.0816 592.722 63.0816",
    fill: "#E5E5E5"
  })));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgOxTxtLogo);
export default __webpack_public_path__ + "static/media/ox-txt-logo.a161a4d12d11531783e6072285bf0f0b.svg";
export { ForwardRef as ReactComponent };